import { render, staticRenderFns } from "./input_tel.vue?vue&type=template&id=8c75b8e4&scoped=true&"
import script from "./input_tel.vue?vue&type=script&lang=js&"
export * from "./input_tel.vue?vue&type=script&lang=js&"
import style0 from "./input_tel.vue?vue&type=style&index=0&id=8c75b8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c75b8e4",
  null
  
)

export default component.exports